import { render, staticRenderFns } from "./addChannel.vue?vue&type=template&id=ec981ab6"
import script from "./addChannel.vue?vue&type=script&lang=js"
export * from "./addChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports